import ZLogo from './ZLogo.vue'

export default ZLogo
